import Section from './Section';

/**
 * Allows the rendered block to pass data to the admin field.
 *
 * This causes a limitation of only being able to have one quick-shop block on a page at a time
 * but that is fine.
 *
 * Note this uses the window object for now instead of an internal var because of
 * an issue where index.js and index-admin.js made two separate instances of this module.
 */
// let storedSections = [];

window['quick-shop-with-sections-admin-communication-singleton-stored-sections'] = [];

export function setSections(sections: Section[]) {
    // storedSections = sections;
    window['quick-shop-with-sections-admin-communication-singleton-stored-sections'] = sections;
}

export function getSections(): Section[] {
    // return storedSections
    return window['quick-shop-with-sections-admin-communication-singleton-stored-sections'];
}
